import { render, staticRenderFns } from "./materialScience_delete.vue?vue&type=template&id=56b9b8f4&scoped=true"
import script from "./materialScience_delete.vue?vue&type=script&lang=js"
export * from "./materialScience_delete.vue?vue&type=script&lang=js"
import style0 from "./materialScience_delete.vue?vue&type=style&index=0&id=56b9b8f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9b8f4",
  null
  
)

export default component.exports